import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    grade_level: '',
    subject: '',
    domain: '',
  },
  goalbankFilters: null,
  goalbankSelection: {},
  curriculumSelection: {}
}

export const clustersUI = createSlice({
  name: 'clustersUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.grade_level = payload
    },
    setSubject: (state, { payload }) => {
      state.tableFilters.subject = payload
    },
    setDomain: (state, { payload }) => {
      state.tableFilters.domain = payload
    },
    setGoalbankFilters: (state, { payload }) => {
      state.goalbankFilters = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGradeLevel,
  setSubject,
  setDomain,
  setGoalbankFilters,
  trackActiveFilters,
  clearAllFilters,
} = clustersUI.actions

export default clustersUI.reducer
